import {
  axiosGetWithCookies,
  axiosPostWithCookies,
  axiosPutWithCookies,
} from './helper';

export const getAssetTypeList = ({
  securityCompanyId,
  archived,
  handoverRequired,
  qualificationRequired,
  category,
  from,
  search,
  limit = 50,
}) => {
  let query = `/assets/assets/types?securityCompanyId=${securityCompanyId}&includeArchived=${archived}&limit=${limit}`;
  if (typeof qualificationRequired === 'boolean' && qualificationRequired) {
    query += `&qualificationRequired=${qualificationRequired}`;
  }
  if (typeof handoverRequired === 'boolean' && handoverRequired)
    query += `&handoverRequired=${handoverRequired}`;
  if (from) query += `&from=${from}`;
  if (category && category !== 'ALL') query += `&category=${category}`;
  if (search) query += `&search=${search}`;
  return axiosGetWithCookies(query);
};

export const createAssetType = assetType =>
  axiosPostWithCookies(`/assets/assets/types`, { data: assetType });

export const updateAssetType = (id, assetType) =>
  axiosPutWithCookies(`/assets/assets/types/${id}`, { data: assetType });
